export const Tag = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-row items-center gap-2 bg-base-accent rounded-lg px-2 py-1">
      <div className="text-[10px] text-base-primary">{text}</div>
    </div>
  );
};
